import { Box, Text } from "@chakra-ui/react";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import APButton from "../../../components/APButton";
import { TransModel } from "../../../types";

interface LoginDrawerSectionProps {
  description: TransModel;
}

export default function LoginDrawerSection({
  description,
}: LoginDrawerSectionProps) {
  const navigate = useNavigate();

  const login = () => {
    navigate("/", { replace: true });
  };

  return (
    <Box
      position={"absolute"}
      padding={6}
      display="flex"
      flexDirection={"column"}
      flex={"1 1 auto"}
      sx={{
        top: "300px",
        height: "calc(100% - 300px)",
        background: "#fff",
        zIndex: 10,
      }}
    >
      <Text px={1} fontWeight={"normal"} lineHeight={1.5} textAlign={"center"}>
        <FormattedMessage
          id="login-and-follow-your-progress"
          defaultMessage={
            "Connecte-toi pour profiter d’une expérience personnalisé et suivre ta progression"
          }
        />
      </Text>
      <APButton
        colorScheme={"primary"}
        boxShadow="0px 4px 0 0 #3398a4"
        minHeight="56px"
        py={4}
        px={10}
        mx={"auto"}
        mt={4}
        onClick={() => login()}
      >
        <FormattedMessage id="login" defaultMessage={"Se connecter"} />
      </APButton>
      <Box position={"absolute"} bottom={0} right={0}>
        <img src={`${process.env.REACT_APP_BASE_URL}/Great.png`} alt="Great" width={200} />
      </Box>
    </Box>
  );
}
